/* eslint-disable */
import { useRef, useEffect } from 'react';
const RichTextBox = ({
	value,
	editing,
	autoFocus = false,
	onChange,
	onClick,
	onBlur,
	className,
	style,
	placeholder,
}) => {
	const ref = useRef(null);

	useEffect(() => {
		const el = ref.current;
		if (el && document.activeElement !== el && el.innerHTML !== (value || '')) {
			el.innerHTML = value || '';
		}
	}, [value]);

	useEffect(() => {
		if (autoFocus && editing && ref.current) ref.current.focus();
	}, [autoFocus, editing]);

	return (
		<div
			ref={ref}
			contentEditable={editing}
			suppressContentEditableWarning
			data-placeholder={placeholder}
			onInput={(e) => onChange(e.currentTarget.innerHTML)}
			onClick={onClick}
			onBlur={onBlur}
			className={className}
			style={style}
		/>
	);
};

export default RichTextBox;
